import React from "react";
import styles from './ArtistSeeAll.module.css';
import { useNavigate, useParams } from "react-router";

const ArtistSeeAll = ({ data }) => {
  const { category_type } = useParams();
  const navigate = useNavigate();

  const handleDetail = (id) => {
    navigate(`/music/detail/${category_type}/${id}`);
  }

  return (
    <div className={`${styles.grid_cols_custom} grid`}>
      {data.map((item, index) => (
        <div key={item.id} className="inline-block truncate text-center"  onClick={() => handleDetail(item.id)}>
          <img src={item.image} alt="" className="rounded-full w-100 object-cover aspect-square" />
          <span className="text-xs mt-2">{item.title}</span>
        </div>
      ))}
    </div>
  );
};

export default ArtistSeeAll;
